// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"8a2e3403","977":"2283bd49"}[chunkId] + ".chunk.js";
};